export const turboTagTextSize = {
  header: '0.875rem',
  dialog: '0.75rem',
} as const;
